import Authenticate from './Authenticate';

export { withAuthenticationContext, useAccount, useLogout, useAccessTokens, useUserProfile } from './Authenticate';
export { getRequiredScopes } from './getRequiredScopes';

export default Authenticate;
